export interface SchoolHit {
    schoolUnitCode: string;
    name: string;
    municipalityName: string | null;
    city: string | null;
    displayName: string;
}

const SEARCH_URL = '/breaks/api/schools/search';

/**
 * Söker skolor i den lokala speglingen av Skolverkets register.
 * Anroparen skickar in en AbortSignal så att träffar från en äldre inmatning
 * kan kastas bort när användaren hinner skriva vidare.
 */
export async function searchSchools(
    name: string,
    signal: AbortSignal,
    take = 8
): Promise<SchoolHit[]> {
    const url = `${SEARCH_URL}?name=${encodeURIComponent(name)}&take=${take}`;
    const response = await fetch(url, {
        signal,
        headers: { Accept: 'application/json' }
    });

    if (!response.ok) {
        throw new Error(`Skolsökningen misslyckades (${response.status}).`);
    }

    return (await response.json()) as SchoolHit[];
}
